// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const IMPORT_PLATES_STEP_SHAPES = [
  {
    stepType: PipelineStepType.IMPORT_PLATES,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {},
    outputDataShapes: {
      'Scratch plates': {
        systemName: 'Scratch plates',
        displayName: 'Scratch plates',
        kind: PipelineStepDataKind.PLATE,
        isMulti: true,
        isRequired: true
      }
    },
    config: {
      scratchPlateIds: {
        kind: 'array',
        required: true,
        elementSpec: {
          kind: 'string',
          required: true
        },
        minItems: 1
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
